var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 290 290",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Scroll_Group_1",
    "data-name": "Scroll Group 1",
    transform: "translate(21 16)",
    clipPath: "url(#clip-path)",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dashboardIcon",
    transform: "translate(126.036 107.175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1890",
    "data-name": "Group 1890",
    transform: "translate(-126.036 -126.036)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2914",
    "data-name": "Path 2914",
    d: "M99.421,149.947H12.531A12.548,12.548,0,0,1,0,137.412V12.531A12.546,12.546,0,0,1,12.531,0h86.89a12.546,12.546,0,0,1,12.531,12.531V137.412A12.545,12.545,0,0,1,99.421,149.947Z",
    transform: "translate(0 18.861)",
    fill: "#2b5889"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2915",
    "data-name": "Path 2915",
    d: "M99.421,251.461H12.531A12.546,12.546,0,0,1,0,238.926V195.219a12.548,12.548,0,0,1,12.531-12.534h86.89a12.546,12.546,0,0,1,12.531,12.534v43.707A12.543,12.543,0,0,1,99.421,251.461Z",
    transform: "translate(0 17.251)",
    fill: "#31f4cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2916",
    "data-name": "Path 2916",
    d: "M238.543,250.739H151.656A12.549,12.549,0,0,1,139.121,238.2V113.324a12.546,12.546,0,0,1,12.534-12.531h86.89a12.548,12.548,0,0,1,12.534,12.531V238.2A12.551,12.551,0,0,1,238.543,250.739Z",
    transform: "translate(-1.226 17.973)",
    fill: "#2b5889"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2917",
    "data-name": "Path 2917",
    d: "M238.543,68.773H151.656a12.549,12.549,0,0,1-12.534-12.534V12.531A12.546,12.546,0,0,1,151.656,0h86.89a12.546,12.546,0,0,1,12.531,12.531v43.71A12.546,12.546,0,0,1,238.543,68.773Z",
    transform: "translate(-1.226 18.861)",
    fill: "#37a7f4"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboardIcon.12dc54e0d7fe7cc1c2cfc9e8dd597034.svg";
export { ForwardRef as ReactComponent };